import axios from 'axios'
import { Product } from 'store/types'

type Config = {
  params: {
    total?: number
    'google-token'?: string
  }
}

type Resp = {
  total: number
  product: Product
}

export default async (config: Config): Promise<Resp> => {
  const response = await axios.get(`${process.env.REACT_APP_PLUSBOX_API}/products/random`, config)
  return response.data
}

export type { Config }
